import { render, staticRenderFns } from "./SalaryExportRecordGrid.vue?vue&type=template&id=867dfa72"
import script from "./SalaryExportRecordGrid.vue?vue&type=script&lang=js"
export * from "./SalaryExportRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports